/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:43:00
 * @Deccription: 这个文件为所有预览相关的状态信息，用于pdf预览， 和图片预览
 */
import TYPES from '../types'

export const previewSate = {
  // 当前预览文件的信息
  previewInfo: {},
  // 是否为幻灯片模式: true 预览模式pdsjs，false 幻灯片模式owa
  isSideMode: false,
  // 右侧是否展开
  isRightOpen: false,
  isFooterHide: false,
  // 历史版本信息
  historyInfo: {},
  curVersionNum: '最新',
}
// export const fileGetters = {
// }
export const previewMutations = {
  [TYPES.GET_PREVIEW_INFO](state, data) {
    state.previewInfo = data
  },
  [TYPES.GET_IS_SIDEMODE](state, data) {
    state.isSideMode = data
  },
  [TYPES.GET_IS_RIGHTOPEN](state, data) {
    state.isRightOpen = data
  },
  [TYPES.GET_IS_RIGHTOPEN](state, data) {
    state.isRightOpen = data
  },
  [TYPES.GET_FOOTER_ISHIDE](state, data) {
    state.isFooterHide = data
  },
  [TYPES.GET_HISTORY_INFO](state, data) {
    state.historyInfo = data
  },
  [TYPES.SET_CUR_VERSIONNUM](state, data) {
    state.curVersionNum = data
  },
}
